import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rk-meinprofil',
  templateUrl: './meinprofil.component.html',
  styleUrls: ['./meinprofil.component.css']
})
export class MeinprofilComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
